import { Heart, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function DonationBanner() {
  return (
    <section className="py-12 bg-accessible-red-600 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-white">
            <div className="flex items-center gap-3 mb-4">
              <Heart className="w-8 h-8 text-white animate-pulse" aria-hidden="true" />
              <h2 className="heading-2-white mb-0">Potrzebujemy Twojej pomocy!</h2>
            </div>
            <p className="body-large-white max-w-xl mb-0">
              Nasze schronisko utrzymuje się wyłącznie z darowizn. Każda wpłata pomaga nam zapewnić 
              opiekę, leczenie i bezpieczny dom dla bezdomnych zwierząt.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/wplata-jednorazowa"
              className="bg-white text-accessible-red-600 px-8 py-4 rounded-lg hover:bg-accessible-gray-50 transition-all duration-300 flex items-center justify-center gap-2 shadow-lg transform hover:scale-105 btn-text-large font-bold"
            >
              <span>WPŁAĆ TERAZ</span>
            </Link>
            <Link
              to="/wsparcie"
              className="bg-white/20 text-white px-8 py-4 rounded-lg hover:bg-white/30 transition-all duration-300 flex items-center justify-center gap-2 backdrop-blur-sm border border-white/30 btn-text-large"
            >
              <span>Inne formy wsparcia</span>
              <ArrowRight className="w-5 h-5 text-white" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}


